import * as ActionTypes from '../redux/ActionTypes';

export default (state=[], action) => {
  if (action.type === ActionTypes.SETAIOT) {
    return  [ ...state, ...action.aiots ];
  } else {
    return state;
  }
}